var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7777 18.8389V15.6129C17.6727 15.6262 17.5614 15.6324 17.4493 15.6324H2.55056C2.43922 15.6324 2.33422 15.6262 2.22217 15.6129V18.8389C2.22217 20.5846 3.65976 22 5.41869 22H14.5812C16.3401 21.9993 17.7777 20.5846 17.7777 18.8389Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6219 9.96244H16.4263V6.27482C16.4263 5.93987 16.1242 5.67743 15.755 5.67743C15.3858 5.67743 15.0836 5.94051 15.0836 6.27482V9.96244H4.91563V6.27482C4.91563 5.93987 4.6135 5.67743 4.2443 5.67743C3.87511 5.67743 3.57297 5.94051 3.57297 6.27482V9.96244H2.37742C1.06793 9.96244 0 10.9127 0 12.078C0 13.2433 1.06793 14.1936 2.37742 14.1936H17.6226C18.9321 14.1936 20 13.2433 20 12.078C20 10.9127 18.9314 9.96244 17.6219 9.96244Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4217 0C8.3514 0 6.66669 1.61406 6.66669 3.59752C6.66669 5.57818 8.3514 7.19224 10.4217 7.19224C12.492 7.19224 14.1767 5.57818 14.1767 3.59752C14.1767 1.61406 12.492 0 10.4217 0ZM11.8013 3.00611L10.1411 4.59675C10.0817 4.65358 10.0042 4.682 9.92627 4.682C9.8487 4.682 9.77081 4.65358 9.71149 4.59675L9.04138 3.95475C8.92275 3.84109 8.92275 3.65717 9.04138 3.5435C9.16002 3.42984 9.35199 3.42984 9.47063 3.5435L9.92627 3.98004L11.3721 2.59486C11.4907 2.4812 11.6827 2.4812 11.8013 2.59486C11.92 2.70853 11.92 2.89245 11.8013 3.00611Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder1);
export default __webpack_public_path__ + "static/media/order1.49278b76623c641aaffee8c533c9fa67.svg";
export { ForwardRef as ReactComponent };